export function CouchLogo({ className = "size-6" }: { className?: string }) {
  return (
    <img
      src="/couch-mascot.png?v=5"
      alt="CouchStack"
      className={className}
    />
  );
}
